import { type AnyAction } from 'redux';
import { CHANGE_LANGUAGE } from './actionTypes/settings';
import { SEND_REQUEST } from './actionTypes/request';
import { REQUEST_TYPES } from '../../api/requests/requestTypes';

export const changeLanguage = (payload: string): AnyAction => ({ type: CHANGE_LANGUAGE, payload });

export const fetchDataPrivacy = (): AnyAction => {
    return {
        type: SEND_REQUEST,
        payload: {},
        request: {
            type: REQUEST_TYPES.GET_DATA_PRIVACY_CONFIG,
            params: {}
        },
        options: {}
    };
};

export const fetchConfiguration = (): AnyAction => {
    return {
        type: SEND_REQUEST,
        payload: {},
        request: {
            type: REQUEST_TYPES.GET_CONFIG,
            params: {}
        },
        options: {}
    };
};
